import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import WarningPage from './WarningPage';
import WarningLoading from './WarningLoading';
import useMyView from './useMyView';
import { WD, FONT_SERIF } from './warningTheme';

// Plain wording, shared with the landing page so both say the same thing.
export const NO_CRO_WORKFLOW_TITLE = "CRO Workflow isn't available for your department";
export const NO_CRO_WORKFLOW_HELP = 'Ask Finance if you need access.';

// Wraps the CRO Pending Tasks result page (see DashboardRouter.js; NOT its settings page). Finance can switch CRO Workflow off for a
// department (Who can see CRO Workflow); a person in such a department who opens the page - from a bookmark, say - gets this plain panel
// with a way back, not an error. The server enforces it too (requireCroWorkflowAccess): this is the friendly part. Waits for the one
// my-view answer (remembered, so it is instant after the landing page). Only an explicit "no" blocks the page: a missing or failed answer
// lets it open, and the server decides.
const CroWorkflowGuard = ({ children }) => {
  const { view, croWorkflow } = useMyView();
  if (view === null) {
    return (
      <WarningPage title="CRO Workflow">
        <WarningLoading />
      </WarningPage>
    );
  }
  if (croWorkflow === false) {
    return (
      <WarningPage
        title="CRO Workflow"
        actions={<Button component={Link} to="/dashboard/warning-dashboard" variant="text">Back to Warning Dashboard</Button>}
      >
        <Box sx={{ textAlign: 'center', py: 6, px: 2, bgcolor: '#fff', border: `1px dashed ${WD.border}`, borderRadius: '16px' }}>
          <Typography sx={{ fontFamily: FONT_SERIF, fontSize: 20, fontWeight: 600 }}>{NO_CRO_WORKFLOW_TITLE}</Typography>
          <Typography sx={{ fontSize: 14, color: WD.inkMuted, mt: 0.75 }}>{NO_CRO_WORKFLOW_HELP}</Typography>
        </Box>
      </WarningPage>
    );
  }
  return children;
};

export default CroWorkflowGuard;
